import Vue from 'vue'

import initApps from 'shared/init-apps'

import Gallery from '../product/gallery.vue'
import RelatedProducts from '../product/related-products.vue'

import '../stylesheets/tailwind.css'

const APP_MAP = {
  'gallery': Gallery
}

initApps(APP_MAP)

document.querySelectorAll('[data-vue-app="related-products"]').forEach(el => {
  new Vue({
    render: (h) => h(RelatedProducts, {
      props: {
        elements: el.children
      }
    })
  }).$mount(el)
})
